import { IconProps } from '../ui/Icon/types';
import Icon from '../ui/Icon';

export default function IconTrash(props: IconProps) {
  return (
    <Icon viewBox="0 0 25 24" {...props}>
      <path
        d="M6.5 19C6.5 20.1 7.4 21 8.5 21H16.5C17.6 21 18.5 20.1 18.5 19V7H6.5V19ZM8.5 9H16.5V19H8.5V9ZM16 4L15 3H10L9 4H5.5V6H19.5V4H16Z"
        fill="currentColor"
      />
    </Icon>
  );
}
